import { ReactNode } from 'react'
import { cn } from '@/lib/utils'

interface DetailPageContentProps {
  children: ReactNode
  className?: string
}

interface DetailPageSidebarProps {
  children: ReactNode
  className?: string
}

interface DetailPageMainProps {
  children: ReactNode
  className?: string
  /**
   * Add top spacing to align with sidebar content (useful when sidebar has a large header)
   */
  alignWithSecondCard?: boolean
}

/**
 * Content wrapper for detail pages with sidebar layout
 */
function DetailPageContent({ children, className }: DetailPageContentProps) {
  return (
    <div className={cn('mt-3 flex flex-col gap-3 lg:flex-row', className)}>
      {children}
    </div>
  )
}

/**
 * Sidebar for detail pages (left side on desktop, bottom on mobile)
 */
function DetailPageSidebar({ children, className }: DetailPageSidebarProps) {
  return (
    <div
      className={cn('order-2 w-full space-y-3 lg:order-1 lg:w-1/4', className)}
    >
      {children}
    </div>
  )
}

/**
 * Main content area for detail pages
 */
function DetailPageMain({
  children,
  className,
  alignWithSecondCard = false,
}: DetailPageMainProps) {
  return (
    <div
      className={cn(
        'order-1 w-full flex-1 space-y-3 lg:order-2',
        alignWithSecondCard,
        className
      )}
    >
      {children}
    </div>
  )
}

/**
 * Layout components for detail pages
 * Use within PageWrapper for complete page structure
 */
export const DetailPageLayout = {
  Content: DetailPageContent,
  Sidebar: DetailPageSidebar,
  Main: DetailPageMain,
}
